module.exports = __webpack_public_path__ + "img/icon-chrome.22673265.svg";